import { Box, IconButton, Popover, popoverClasses, styled } from '@mui/material'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export const StyledIconButton = styled(IconButton)(({ theme }) => ({
  width: '2.25rem',
  height: '2.25rem',
  borderRadius: '3px',

  [`${StyledIcon}`]: {
    color: theme.palette.grey[100],
  },

  ':hover, :focus-visible': {
    backgroundColor: theme.palette.grey[700],
    [`${StyledIcon}`]: {
      color: theme.palette.common.white,
    },
  },

  '&.active': {
    backgroundColor: theme.palette.blue[600],
    [`${StyledIcon}`]: {
      color: theme.palette.common.white,
    },
  },
}))

export const StyledIcon = styled(FontAwesomeIcon)(({ theme }) => ({
  fontSize: theme.typography.body2.fontSize,
}))

export const AccessibilityMenuWrapper = styled(Popover)(({ theme }) => ({
  [`& .${popoverClasses.paper}`]: {
    width: `224px`,
    padding: 0,
    boxShadow: theme.shadows[6],
    borderRadius: `3px`,
  },
}))

export const MenuContent = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  padding: theme.spacing(1, 0),

  '& > *:not(:last-child)': {
    borderBottom: `1px solid ${theme.palette.grey[100]}`,
  },
}))
